import React, { useEffect, useState } from 'react';

interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}

let toastId = 0;
const listeners: Set<(toast: Toast) => void> = new Set();

export const showToast = (message: string, type: 'success' | 'error' | 'info' = 'info') => {
  const id = toastId++;
  const toast = { id, message, type };
  listeners.forEach(listener => listener(toast));
  setTimeout(() => removeToast(id), 3000);
};

export const removeToast = (id: number) => {
  listeners.forEach(listener => listener({ id, message: '', type: 'info' }));
};

function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const listener = (toast: Toast) => {
      if (toast.message) {
        setToasts(prev => [...prev, toast]);
      } else {
        setToasts(prev => prev.filter(t => t.id !== toast.id));
      }
    };

    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      {toasts.map(toast => (
        <div
          key={toast.id}
          style={{
            padding: '12px 16px',
            borderRadius: '4px',
            color: 'white',
            fontWeight: 600,
            animation: 'slideIn 0.2s ease-in',
            backgroundColor:
              toast.type === 'success'
                ? '#4caf50'
                : toast.type === 'error'
                ? '#f44336'
                : '#2196f3',
          }}
        >
          {toast.message}
        </div>
      ))}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default Toaster;
